import {useState, useEffect, useRef} from "react";
import CommonAPI from '~/api/commonApi';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCog} from "@fortawesome/free-solid-svg-icons";

function Table({ tableConfig }) {
    const {columns = [], data = [], tableKey = "Empty", hasShowHideColumn = true } = tableConfig;
    const [expandedCells, setExpandedCells] = useState({});
    const [visibleColumns, setVisibleColumns] = useState([]);
    const [tempColumns, setTempColumns] = useState([]);
    useEffect(() => {
        CommonAPI.getColumnSetting(tableKey)
            .then(res => {
                if (res.data?.VisibleColumns) {
                    setVisibleColumns(JSON.parse(res.data.VisibleColumns == "" ? "[]" : res.data.VisibleColumns));
                    setTempColumns(JSON.parse(res.data.VisibleColumns == "" ? "[]" : res.data.VisibleColumns))
                } else {
                    setVisibleColumns(columns.map(c => c.key));
                    setTempColumns(columns.map(c => c.key));
                }
            })
            .catch(err => {});
    }, [tableKey, columns]);

    const toggleTempColumn = (key) => {
        setTempColumns(prev =>
            prev.includes(key)
                ? prev.filter(c => c !== key)
                : [...prev, key]
        );
    };

    const visibleColumnsRef = useRef([]);
    useEffect(() => {
        visibleColumnsRef.current = visibleColumns;
    }, [visibleColumns]);


    const handleSaveChangesColumnConfig = () => {
        const payload = {
            TableKey: tableKey,
            VisibleColumns: JSON.stringify(tempColumns)
        }
        CommonAPI.insUpdColumnSetting(payload)
            .then(res => {
                setVisibleColumns([...tempColumns]);
                visibleColumnsRef.current = [...tempColumns];
            })
            .catch(err => {})
            .finally(() => {
                const dropdownElement = document.getElementById("dropdownColumnConfig");
                const dropdownInstance = window.bootstrap.Dropdown.getInstance(dropdownElement);
                dropdownInstance.hide();
            });
    };

    const toggleCell = (rowIndex, colKey) => {
        const cellId = `${rowIndex}-${colKey}`;
        setExpandedCells(prev => ({
            ...prev,
            [cellId]: !prev[cellId]
        }));
    };

    useEffect(() => {
        const dropdownElement = document.getElementById("dropdownColumnConfig");
        if (!dropdownElement) return;

        dropdownElement.addEventListener("hidden.bs.dropdown", () => {
            setTempColumns(visibleColumnsRef.current);
        });

        return () => {
            dropdownElement.removeEventListener("hidden.bs.dropdown", () => {});
        };
    }, []);

    return (
        <div>
            {
                hasShowHideColumn &&
                <div className="dropdown mt-3 mb-2">
                    <a href='#!' data-bs-toggle="dropdown" role="button"
                       className="text-primary d-inline-block fw-bold nav-link dropdown-toggle dropdown-caret-none fs-9 text-decoration-underline"
                       aria-expanded="false"
                       id="dropdownColumnConfig"
                       data-bs-auto-close = "outside"
                    > <FontAwesomeIcon icon={faCog} className="me-1" />
                        Show/Hide Column Config
                    </a>
                    <div
                        className="dropdown-menu navbar-dropdown-caret py-0 shadow border"
                        aria-labelledby="dropdownColumnConfig"
                        onClick={(e) => e.stopPropagation()}>
                        <div className="card position-relative border-0"
                            style={{maxHeight: '500px', overflowX: 'hidden', overflowY: 'auto'}}>
                            <div className="card-header mb-2 py-3">
                                <div className="text-center">
                                    <button onClick={handleSaveChangesColumnConfig} className="btn btn-bt-primary">Save Changes</button>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                <div className="px-3 py-2">
                                    <div className="g-0 row" style={{maxWidth: '380px'}}>
                                        {columns.map((col, i) => (
                                            <div key={i} className="col-sm-6">
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input cursor-pointer"
                                                        id={`chk-${col.key}`}
                                                        checked={tempColumns.includes(col.key)}
                                                        onChange={() => toggleTempColumn(col.key)}
                                                    />
                                                    <label
                                                        className="form-check-label fs-9 fw-semibold"
                                                        htmlFor={`chk-${col.key}`}
                                                    >
                                                        {col.name.toLowerCase()
                                                            .replace(/\b\w/g, (char) => char.toUpperCase())}
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <div className="table-responsive scrollbar ms-n1 ps-1">
                <table className="table table-sm fs-9 mb-0">
                    <thead>
                    <tr>
                        {columns.map((col, index) =>
                            visibleColumns.includes(col.key) ? (
                                <th
                                    key={index}
                                    className={`align-middle ${col.headerClassName ? col.headerClassName : ""} ${index === 0 ? "ps-0" : ""}`}
                                    style={{ minWidth: col.width || 'auto' }}
                                >
                                    {col.type === "checkbox" ? (
                                        <div className="form-check fs-8 mb-0">
                                            <input type="checkbox" className="form-check-input" />
                                        </div>
                                    ) : (
                                        col.name || ""
                                    )}
                                </th>
                            ) : null
                        )}
                    </tr>
                    </thead>
                    <tbody>
                    {data.map((row, rIndex) => (
                        <tr key={rIndex}>
                            {columns.map((col, cIndex) => {
                                if (!visibleColumns.includes(col.key)) return null;

                                const cellId = `${rIndex}-${col.key}`;
                                const content = col.template ? col.template(row) : row[col.key];
                                const isExpanded = expandedCells[cellId];
                                const shouldTruncate = col.isMoreLess && typeof content === "string" && content.length > 100;
                                const displayContent = shouldTruncate && !isExpanded ? content.slice(0, 100) + "..." : content;

                                return (
                                    <td
                                        key={cIndex}
                                        className={`align-middle pt-2 pb-2 ${col.className ? col.className : ""}`}
                                    >
                                        {displayContent}
                                        {shouldTruncate && (
                                            <a
                                                href="#"
                                                className="ms-2 text-primary"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    toggleCell(rIndex, col.key);
                                                }}
                                            >
                                                {isExpanded ? "less" : "more"}
                                            </a>
                                        )}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Table;
